//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { IntegracoesContext } from "../context/IntegracoesContext";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ContainerSearch() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { integrationSearched, setIntegrationSearched } = useContext(IntegracoesContext); // Estado que armazena o texto da Busca



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* INPUT DE PESQUISA DE TAG */}
            <input
                type="text"
                placeholder="Buscar integrações"
                value={integrationSearched}
                onChange={(e) => setIntegrationSearched(e.target.value)}
                className="bg-surface-2 text-white p-2 rounded border border-white/[0.08]"
            />

        </>
    )
}